import { render, staticRenderFns } from "./module-card.vue?vue&type=template&id=6957791e&scoped=true&"
import script from "./module-card.vue?vue&type=script&lang=js&"
export * from "./module-card.vue?vue&type=script&lang=js&"
import style0 from "./module-card.vue?vue&type=style&index=0&id=6957791e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6957791e",
  null
  
)

export default component.exports